import { unitsToDecimal } from './money.js';
/** Preset labels never hide fractional amounts behind a rounded whole-number label. */
export function formatFundingPreset(units, decimals, currency, locale) {
    const amount = BigInt(units);
    const scale = 10n ** BigInt(decimals);
    if (amount % scale !== 0n)
        throw new Error('onramp_invalid_preset');
    return formatFiatUnits((amount / scale).toString(), 0, currency, locale);
}
/** Formats recorded fiat minor units without converting money through a JS number or FX. */
export function formatFiatUnits(units, decimals, currency, locale) {
    if (!/^\d{1,128}$/.test(units) || !/^[A-Z]{3}$/.test(currency))
        throw new Error('onramp_invalid_money');
    const decimal = unitsToDecimal(BigInt(units), decimals);
    const [whole = '0', fraction = ''] = decimal.split('.');
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
    const digits = new Intl.NumberFormat(locale, { useGrouping: false });
    const localizedFraction = [...fraction].map((digit) => digits.format(BigInt(digit))).join('');
    return formatter
        .formatToParts(BigInt(whole))
        .map((part) => (part.type === 'fraction' ? localizedFraction : part.value))
        .join('');
}
